var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-flex ai-baseline"},[_vm._t("pre"),_c('span',{staticClass:"d-flex flex-1-1 m-y-1"},[_c('span',{staticClass:"BAR bg-depot",style:({ width: `${_vm.width}%` })}),_c('span',{staticClass:"BAR bg-gray30",style:({ width: `${_vm.rest}%` })})]),_vm._t("post")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }